import { render, staticRenderFns } from "./BalanceUnder.vue?vue&type=template&id=235cb7c3&scoped=true"
import script from "./BalanceUnder.vue?vue&type=script&lang=js"
export * from "./BalanceUnder.vue?vue&type=script&lang=js"
import style0 from "./BalanceUnder.vue?vue&type=style&index=0&id=235cb7c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235cb7c3",
  null
  
)

export default component.exports